// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Radio__pc_only___1UMnP","sp_only":"Radio__sp_only___2lg_X","radio":"Radio__radio___17P_0"};